import { filter, map } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { IRoutePaths, ROUTES_CONSTANT } from '@app-core/constants';
import { NotificationCenterService } from '@app-core/services/notification-center/notification-center.service';
import { AuthUser } from '@app-units/models/auth-user/auth-user';
import { PROFILE_ROLE } from '@app-units/models/profile/profile';
import { AuthService } from '@ss-core/services';

/**
 * @classdesc ログイン者情報を表示
 * @export
 * @class AuthUserProfileComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'auth-user-profile',
  templateUrl: './auth-user-profile.component.html',
  styleUrls: ['./auth-user-profile.component.scss'],
})
export class AuthUserProfileComponent implements OnInit {
  /** ログイン者情報 */
  authUser: AuthUser;
  // チラッと表示されないように初期値をtrueにしておく（login.component.ts と同様）
  isPrivate = true;

  constructor(
    @Inject(ROUTES_CONSTANT) private ROUTES_CONSTANT: IRoutePaths,
    private router: Router,
    private notificationCenterService: NotificationCenterService,
    private authService: AuthService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    // ログイン者情報を取得
    this.authUser = this.authService.authUser();

    // 管理画面かクライアントポータルか判定（/app_mode から取得。login.component.ts と同様）
    this.http
      .get<{ data: { is_private: boolean } }>('/app_mode')
      .pipe(map((res) => res.data.is_private ?? true))
      .subscribe((isPrivate) => (this.isPrivate = isPrivate));
  }

  /**
   * パスワード変更メニューを表示するかどうか
   * FR-1-1: manage.gaiheki.support の各ログインユーザーが対象（クライアントポータルでは対象外）。
   * AFFILIATE はフォーム連携用の自動ロールで、通常ログインして使う対象ではないため除外する
   */
  canChangeOwnPassword(): boolean {
    return (
      this.isPrivate && this.authUser?.profile?.role !== PROFILE_ROLE.AFFILIATE
    );
  }

  /**
   * ログアウト処理
   */
  onLogout() {
    this.authService
      .logout()
      .pipe(filter((res) => res.result))
      .subscribe(() => {
        this.notificationCenterService.logoutSucceed$.next();
        location.href = '/';
      });
  }

  /**
   * パスワード変更
   */
  onPasswordChangeClick() {
    this.router.navigate([this.ROUTES_CONSTANT.MY_PASSWORD.path]);
  }

  /**
   * プロフィール
   */
  onProfileClick() {
    this.router.navigate([
      this.ROUTES_CONSTANT.USERS.path,
      this.ROUTES_CONSTANT.COMMON.VIEW.path,
      this.authUser.id,
    ]);
  }
}
